<template>
  <div class="wg-offical-web">
    <div
      class="wg-offical-web-header"
      :style="{ transform: `scale(${scale})` }"
    >
      <div class="wg-offical-web-header-inner">
        <img class="icon" src="@/assets/images/wg-icon.png" />
        <div class="router-tabs">
          <div
            :class="[
              'router-tab',
              item.path == selectedRoute ? 'selected-tab' : '',
            ]"
            v-for="item in routerTabs"
            :key="item.id"
            @click="changePage(item)"
          >
            <img
              v-if="item.path == selectedRoute"
              class="selected-tab-icon"
              src="@/assets/images/Ellipse.png"
            />
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="wg-offical-web-inner" ref="contRef">
      <div
        class="wg-offical-web-main"
        :style="{ transform: `scale(${scale})` }"
      >
        <RouterView />
        <div class="wg-offical-web-footer">
          <div class="wg-offical-web-footer-d"></div>
          <div class="wg-offical-web-footer-info">
            <img class="footer-incon" src="@/assets/images/footer-icon.png" />
            <div class="info">
              <div class="footer-title">西部创源</div>
              <div class="footer-sub-title">
                <!-- 领先的智能化场景数据服务与应用技术供应商 -->
                AI驱动的场景数据服务与应用技术供应商
              </div>
              <div class="footer-copyright">
                Copyright © 2025 西部创源智行科技（重庆）有限公司
                渝ICP备2024024633号
              </div>
            </div>
            <div class="mark">
              <!-- textAlign: 'center', -->
              <!-- :popper-class="popper - wg" -->
              <el-popover
                :popper-style="{
                  color: '#ffffff',
                  border: 0,
                  background:
                    'radial-gradient(ellipse 33.99% 69.22% at 1.88% 0%, rgba(103, 62, 183, 0.2) 0%, rgba(103, 62, 183, 0) 100%), rgba(35, 49, 89, 0.8)',
                }"
                :show-arrow="false"
                v-for="(item, index) in infoList"
                :key="index"
                placement="top"
                :width="200"
                trigger="hover"
                content=""
              >
                <template #reference>
                  <img
                    @click="copyInfo(item)"
                    :src="item.icon"
                    class="mark-icon"
                  />
                </template>
                <!-- <div>{{ item.name }}：</div> -->
                <div class="contentText" v-html="item.content"></div>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { RouterView } from "vue-router";
import { ref, onMounted, onUnmounted, watch, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useClipboard } from "@vueuse/core";
import { ElMessage } from "element-plus";
// 视窗监听
const windowWidth = ref(window.innerWidth);
const scale = ref(1);
const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth;
};
watch(
  windowWidth,
  (newVal) => {
    if (windowWidth.value < 1512) {
      scale.value = (windowWidth.value / 1512).toFixed(2);
    } else {
      scale.value = 1;
    }
  },
  { immediate: true }
);
// 路由
const selectedRoute = ref("/home");
const routerTabs = [
  {
    id: 1,
    name: "首页",
    path: "/home",
  },
  {
    id: 2,
    name: "AI数据构建",
    path: "/dataConstruction",
  },
  {
    id: 3,
    name: "AI数据应用",
    path: "/dataApplication",
  },
  {
    id: 4,
    name: "关于我们",
    path: "/aboutUs",
  },
];
const router = useRouter();
const route = useRoute();

const changePage = (item) => {
  if (item.id == selectedRoute.value) {
    return;
  }
  selectedRoute.value = item.id;
  router.push(item.path);
};
const contRef = ref();
const scrollToTop = () => {
  nextTick(() => {
    let scrollElem = contRef.value;
    scrollElem.scrollTop = 0;
    // scrollElem.scrollTo({ top: 0, behavior: "smooth" });
  });
};
const scrollToInfo = () => {
  nextTick(() => {
    let scrollElem = contRef.value;
    let scrollHeight = (scrollElem.clientWidth * 0.5052 + 1036).toFixed(0);
    scrollElem.scrollTop = scrollHeight;
  });
};

watch(
  () => route,
  (newVal) => {
    let newPath = newVal.path || "/home";
    selectedRoute.value = newPath;
    let toInfo = newVal.query?.toInfo;
    if (toInfo) {
      scrollToInfo();
    } else {
      scrollToTop();
    }
  },
  {
    deep: true,
    immediate: true,
  }
);
// 底部信息栏
const infoList = [
  {
    name: "联系电话",
    icon: require("@/assets/images/fi1.png"),
    content: "13883097795 陈先生",
  },
  {
    name: "邮箱",
    icon: require("@/assets/images/fi2.png"),
    content: "Business@westgenesis.com<br/>GenTech@westgenesis.com",
  },
  // {
  //   name: "微信",
  //   icon: require("@/assets/images/fi3.png"),
  // },
  {
    name: "地址",
    icon: require("@/assets/images/fi4.png"),
    content: "重庆市高新区科学谷F4-C栋",
  },
];

const copyInfo = (item) => {
  try {
    const { copy, copied } = useClipboard({ source: item.content });
    copy();
    ElMessage({
      message: `${item.name}已复制到剪切板`,
      type: "success",
    });
  } catch (e) {
    //
  }
};
onMounted(() => {
  window.addEventListener("resize", updateWindowWidth);
});
onUnmounted(() => {
  window.removeEventListener("resize", updateWindowWidth);
});
</script>
<style scoped lang="scss">
.contentText {
  font-family: PuHuiTiThin !important;
}
.wg-offical-web {
  width: 100vw;
  height: 100vh;
  background: #141a29;
  position: relative;
  overflow: hidden;
  .wg-offical-web-header {
    position: absolute;
    z-index: 99;
    width: 100%;
    height: 60px;
    top: 20px;
    left: 0;
    .wg-offical-web-header-inner {
      max-width: 1472px;
      min-width: 1440px;
      margin: 0 auto;
      height: 60px;
      background: radial-gradient(
          ellipse 33.99% 69.22% at 1.88% 0%,
          rgba(103, 62, 183, 0.2) 0%,
          rgba(103, 62, 183, 0) 100%
        ),
        rgba(35, 49, 89, 0.8);
      border: 1px solid;
      border-color: #42508d;
      border-radius: 1000px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .icon {
        width: 148px;
        height: 44px;
        margin-left: 10px;
      }
      .router-tabs {
        display: flex;
        gap: 90px;
        align-items: center;
        margin-right: 40px;

        .router-tab {
          height: 60px;
          line-height: 60px;
          color: #9ab2d6;
          font-size: 18px;
          cursor: pointer;
        }
        .selected-tab {
          color: #ffffff;
          position: relative;
          .selected-tab-icon {
            position: absolute;
            width: 54px;
            height: 54px;
            top: 50%;
            left: -27px;
            transform: translate(0, -50%);
          }
        }
      }
    }
  }
  .wg-offical-web-inner {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .wg-offical-web-main {
      margin: 0 auto;
    }
  }
  .wg-offical-web-footer {
    margin-top: 20px;
    width: 100%;
    .wg-offical-web-footer-d {
      width: 100%;
      height: 180px;
      background: #141a29;
    }
    .wg-offical-web-footer-info {
      position: relative;
      padding: 42px 224px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info {
        position: relative;
        z-index: 2;
        height: 115px;
        .footer-title {
          height: 34px;
          line-height: 34px;
          color: #ffffff;
          font-size: 28px;
        }
        .footer-sub-title {
          height: 24px;
          line-height: 24px;
          margin-top: 10px;
          color: #ffffff;
          font-size: 20px;
        }
        .footer-copyright {
          height: 14px;
          line-height: 14px;
          margin-top: 33px;
          color: #9ab2d6;
          font-size: 12px;
        }
      }
      .mark {
        display: flex;
        gap: 24px;
        .mark-icon {
          width: 60px;
          height: 60px;
          cursor: pointer;
        }
      }
      .footer-incon {
        z-index: 1;
        position: absolute;
        bottom: 0;
        left: 124px;
        width: 230px;
        height: 187px;
      }
    }
  }
  .popper-wg {
    position: relative;
    &::after {
      position: absolute;
      content: "2";
      color: red;
    }
  }
}
</style>
